const qs = require('qs');
const defaults = {
    ignoreQueryPrefix: true,
    arrayFormat: 'brackets',
    arrayLimit: 500
};

export default {
    stringify: qs.stringify,
    parse: function(str, opts = {}) {
        return qs.parse(str, {
            ...defaults,
            ...opts
        });
    }
}
